/**
 * @author      david.loehr@zumper.com (David Loehr)
 * @copyright   Copyright (c) 2023, Zumper
 * @description TourSummary
 */

import { HStack, Stack, type StackProps, Text, VStack } from '@chakra-ui/react'
import { calendarGray900 } from '@zcode-ui/icons'
import { formatInTimeZone } from 'date-fns-tz'
import React from 'react'
import { useSelector } from 'react-redux'
import {
  selectSelectedTime,
  selectSelectedTourType,
} from '../../../../modules/multifamilyTourTimePicker/selectors'
import { DEFAULT_TZ } from '../TourAvailabilityPicker/helpers'
import { getTourTypeLabel } from '../TourOptions/helpers/tourTypeLabels'

export const TourSummary = ({
  hideTimeAndType,
  tz,
  ...props
}: Omit<StackProps, 'as'> & { hideTimeAndType?: boolean; tz: string | null }) => {
  const date = useSelector(selectSelectedTime)
  const type = useSelector(selectSelectedTourType)
  const showTime = date && !hideTimeAndType
  tz = tz ?? DEFAULT_TZ

  return (
    <HStack<'div'> align="center" spacing={4} {...props}>
      <Stack
        _before={{
          backgroundColor: 'blue.800',
          content: '""',
          display: 'block',
          height: 5,
          maskImage: `url(${calendarGray900})`,
          width: 5,
        }}
        align="center"
        backgroundColor="neutral.150"
        borderRadius="full"
        height={10}
        justify="center"
        role="img"
        width={10}
      />
      <VStack<'div'> align="flex-start" spacing={0}>
        <Text color="gray.950" fontWeight="extrabold">
          {date && formatInTimeZone(date.getTime(), tz, 'EEEE MMM d')}
        </Text>
        {!hideTimeAndType && (
          <Text color="gray.950" variant="body16Reg">
            {getTourTypeLabel(type)} tour
            {showTime && `, ${formatInTimeZone(date.getTime(), tz, 'h:mm a').toLowerCase()}`}
          </Text>
        )}
      </VStack>
    </HStack>
  )
}
